import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import { EventsPageCommentsListItem } from 'ui/_pages/events/event/comments/EventsPageCommentsListItem';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export const EventsPageCommentsList = withCustomComponent(
  'EventsPageCommentsList'
)(
  inject(
    'appStore',
    'eventsStore'
  )(
    withRouter(
      observer(({ router, appStore, eventsStore }) => {
        const { t } = useTranslation();
        const { eventPage } = eventsStore;
        const event = eventsStore.eventPage.Event;
        const { business } = appStore;

        return (
          <>
            {event.Comments.length > 0 &&
              <ul className="list-unstyled mb-0">
                <TransitionGroup className="comments-list">
                  {event.Comments.map((comment, i) => (
                    <CSSTransition
                      key={comment.Id}
                      timeout={200}
                      classNames="comment"
                    >
                      <li className="mb-8">
                        <EventsPageCommentsListItem comment={comment} />
                      </li>
                    </CSSTransition>
                  ))}
                </TransitionGroup>
              </ul>
            }
          </>
        );
      })
    )
  )
);
